import { Link } from "react-router-dom";

export function Logo({ light = false, testId = "nav-logo" }) {
  return (
    <Link to="/" data-testid={testId} className={`font-heading font-extrabold text-2xl tracking-tighter transition-colors ${light ? "text-white" : "text-navy"}`}>
      vorra<span className="text-teal">.</span>
    </Link>
  );
}
